export type SheetName = 'Orders' | 'Customers' | 'Invoices' | 'Sync Logs';

export const SHEET_HEADERS: Record<SheetName, string[]> = {
  Orders: [
    'rr_order_id', 'order_number', 'status', 'customer_id', 'customer_name',
    'pickup_name', 'pickup_address', 'pickup_city', 'pickup_state', 'pickup_postal_code',
    'delivery_name', 'delivery_address', 'delivery_city', 'delivery_state', 'delivery_postal_code',
    'pickup_date', 'delivery_date', 'carrier_name', 'driver_name', 'equipment_type',
    'reference_number', 'rate', 'currency', 'rr_created_at', 'rr_updated_at', 'synced_at', 'sync_hash',
  ],
  Customers: [
    'rr_customer_id', 'customer_name', 'email', 'phone', 'billing_address',
    'billing_city', 'billing_state', 'billing_postal_code', 'billing_country',
    'rr_created_at', 'rr_updated_at', 'synced_at', 'sync_hash',
  ],
  Invoices: [
    'rr_invoice_id', 'invoice_number', 'rr_order_id', 'order_number', 'customer_name',
    'status', 'amount', 'currency', 'issued_date', 'due_date', 'rr_created_at',
    'rr_updated_at', 'synced_at', 'sync_hash',
  ],
  'Sync Logs': [
    'run_id', 'started_at', 'finished_at', 'entity', 'status', 'fetched_count',
    'created_count', 'updated_count', 'skipped_count', 'failed_count', 'message', 'error_details',
  ],
};
